import { render, staticRenderFns } from "./discount-cart-item.vue?vue&type=template&id=3697097a&scoped=true"
import script from "./discount-cart-item.vue?vue&type=script&lang=js"
export * from "./discount-cart-item.vue?vue&type=script&lang=js"
import style0 from "./discount-cart-item.vue?vue&type=style&index=0&id=3697097a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b5e12a4b1c1729405afdf532a227c02e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3697097a",
  null
  
)

export default component.exports